<div id="risk-indicator-inner-container">
  <img src="assets/img/icons/tacometer-arc.png">
  <div [id]="'power-gauge'+gaugeId"></div>
  <div id="power-gauge-subtext">
    <span class="credit-score-label">{{labelName}}</span>
    <span class="credit-score" *ngIf="!labelValue">{{data}}%</span>
    <span class="credit-score" *ngIf="labelValue">{{labelValue}}</span>
  </div>
</div>